import React from 'react'
import { Layout, Button, Avatar, Dropdown } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { toggleCollapsed, setTheme, logout } from '@/store/slices/userSlice'
import { ConnectWallet } from '@/components/Web3/ConnectWallet'

const { Header: AntHeader } = Layout

interface HeaderProps {
  collapsed: boolean
  currentTheme: 'light' | 'dark'
  onMobileMenuToggle: () => void
  isMobile: boolean
  style?: React.CSSProperties
}

const Header: React.FC<HeaderProps> = ({ collapsed, currentTheme, onMobileMenuToggle, isMobile, style }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.user.user)

  // 处理登出
  const handleLogout = () => {
    dispatch(logout())
    navigate('/login')
  }

  // 用户菜单
  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人中心',
      onClick: () => navigate('/profile'),
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '设置',
      onClick: () => navigate('/settings'),
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ]

  return (
    <AntHeader
      className="admin-header"
      style={{
        background: style?.background,
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...style,
      }}
    >
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => {
          if (isMobile) {
            onMobileMenuToggle()
          } else {
            dispatch(toggleCollapsed())
          }
        }}
        style={{ fontSize: '16px', width: 64, height: 64 }}
      />
      <div className="admin-header-right" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <ConnectWallet />
        <Button
          type="text"
          onClick={() => dispatch(setTheme(currentTheme === 'light' ? 'dark' : 'light'))}
        >
          {currentTheme === 'light' ? '🌙' : '☀️'}
        </Button>
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          arrow
        >
          <div className="admin-user">
            <Avatar icon={<UserOutlined />} />
            <span className="admin-username">{user?.nickname || user?.username}</span>
          </div>
        </Dropdown>
      </div>
    </AntHeader>
  )
}

export default Header

